import React, { useState, useEffect } from 'react';
import { 
  Lock, Eye, Wifi, ShieldAlert, ThumbsUp, Share2, TrendingUp, Hash, Trash2, Fish, 
  Bell, Download, Bookmark, Award, Users, Clock, BarChart2, Star,GraduationCap,HardDrive,
  AlertTriangle, ChevronRight, Filter, Search, RefreshCw, Globe, Key, Smartphone, File,
} from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; 

const EnhancedSecDashboard = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredTools, setFilteredTools] = useState([]);
  const [sortBy, setSortBy] = useState('trending');
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();
  
  // Categories for tools
  const categories = [
    { id: 'all', name: 'All Tools' },
    { id: 'encryption', name: 'Encryption' },
    { id: 'monitoring', name: 'Monitoring' },
    { id: 'defense', name: 'Defense' },
    { id: 'compliance', name: 'Compliance' }
  ];
  
  
  
  // More detailed and expanded security tools data
  const securityTools = [
    /*{
      id: 'secure-deletion',
      name: 'Secure Data Erasure',
      icon: <Trash2 className="w-8 h-8 text-white" />,
      description: 'Military-grade data destruction with certified erasure methods',
      longDescription: 'Permanently erase sensitive data with DoD 5220.22-M compliant methods. Our tool ensures complete data sanitization across all storage media with verifiable audit trails.',
      color: 'bg-red-600',
      link: '/SecDel',
      rating: 4.8,
      totalRatings: 932,
      likes: 2870,
      isNew: false,
      isPremium: false,
      trendingScore: 89,
      category: 'data-protection',
      usageStats: { orgs: 3100, deployments: 14200 },
      lastUpdated: '1 week ago',
      features: ['DoD 5220.22-M compliant', 'Multi-pass overwrite', 'Audit reporting'],
      badges: ['NIST SP 800-88', 'GDPR Compliant'],
      compatibleWith: ['HDD', 'SSD', 'Mobile Devices', 'Cloud Storage']
    },*/
    {
      id: 'mobile-email-analysis',
      name: 'Trace Master/ Mobile & Email',
      icon: <Smartphone className="w-8 h-8 text-white" />,
      description: 'Advanced threat detection for mobile devices and email communications',
      longDescription: 'Comprehensive analysis of mobile apps and email content to detect malware, phishing attempts, and data exfiltration vectors with behavioral analysis.',
      color: 'bg-blue-600',
      link: '/TraceMaster',
      rating: 4.6,
      totalRatings: 754,
      likes: 2150,
      isNew: true,
      isPremium: false,
      trendingScore: 91,
      category: 'threat-detection',
      usageStats: { orgs: 2450, deployments: 9800 },
      lastUpdated: '3 days ago',
      features: ['App behavior analysis', 'Email header inspection', 'Attachment sandboxing'],
      badges: ['OWASP Compliant', 'Zero-Day Detection'],
      compatibleWith: ['iOS', 'Android', 'Exchange', 'Gmail']
    },
     {
      id: 'subnetIQ',
      name: 'SubnetIQ Network Calculator',
      icon: <Globe className="w-8 h-8 text-white" />, 
      description: 'Intelligent IPv4 & IPv6 subnet calculation, visualization, and validation',
      longDescription: 'Analyze and visualize your network with IPv4 and IPv6 subnet calculations, topology mapping, interactive graphs, and comprehensive validation tools. Includes VLAN support.',
      color: 'bg-green-600',
      link: '/SubnetIQ',
      rating: 4.7,
      totalRatings: 680,
      likes: 1950,
      isNew: false,
      isPremium: false,
      trendingScore: 85,
      category: 'network-analysis',
      usageStats: { orgs: 1800, deployments: 7200 },
      lastUpdated: '5 days ago',
      features: ['IPv4/IPv6 Subnet Calculator', 'Topology Visualization', 'Interactive Network Graphs', 'Subnet Validation', 'VLAN Support'],
      badges: ['Network Utility', 'IPAM'],
      compatibleWith: ['All Network Devices', 'Cloud Networks']
    },
     {
      id: 'metaflyse',
      name: 'MetaFlyse Metadata Tool',
      icon: <File className="w-8 h-8 text-green-500" />, 
      description: 'Extract, edit, add, or delete metadata in files, including hidden data.',
      longDescription: 'MetaFlyse allows comprehensive metadata management across multiple file formats, including discovering hidden data and providing full control over file information.',
      color: 'bg-purple-600',
      link: '/metaflyse',
      rating: 4.7,
      totalRatings: 520,
      likes: 1500,
      isNew: true,
      isPremium: false,
      trendingScore: 88,
      category: 'file-management',
      usageStats: { orgs: 1800, deployments: 5600 },
      lastUpdated: '2 days ago',
      features: ['Metadata extraction', 'Hidden data discovery', 'Metadata editing and deletion', 'Supports multiple formats'],
      badges: ['Forensic Tool', 'Data Privacy'],
      compatibleWith: ['All major OS', 'Common file formats']
    },  
    {
      id: 'trisec-graphauth',
      name: 'TriSec GraphAuth',
      icon: <Shield className="w-8 h-8 text-red-500" />, 
      description: 'Three-level image graph authentication for layered user verification.',
      longDescription: 'TriSec GraphAuth provides an innovative layered image-based authentication system that enhances security by requiring three distinct visual challenges, resistant to phishing and spoofing.',
      color: 'bg-red-700',
      link: '/3lelvelAuth',
      rating: 4.8,
      totalRatings: 430,
      likes: 1300,
      isNew: true,
      isPremium: false,
      trendingScore: 90,
      category: 'authentication',
      usageStats: { orgs: 1500, deployments: 4500 },
      lastUpdated: '1 day ago',
      features: ['Three-layer image verification', 'Spoofing resistant', 'User-friendly visuals', 'Enhanced layered security'],
      badges: ['Innovative Technology', 'User Experience'],
      compatibleWith: ['Web', 'Mobile']
    },
    {
      id: 'threat-eye',
      name: 'ThreatEye',
      icon: <Eye className="w-8 h-8 text-white" />, 
      description: 'Comprehensive vulnerability scanning tool for web applications and infrastructure',
      longDescription: 'Advanced vulnerability scanning that identifies, evaluates, and helps mitigate security risks in applications and infrastructure with real-time reporting.',
      color: 'bg-green-600', 
      link: '/VScanner', 
      rating: 4.9,
      totalRatings: 482,
      likes: 1300,
      isNew: true,
      isPremium: true,
      trendingScore: 95,
      category: 'vulnerability-scanning',
      usageStats: { orgs: 1800, deployments: 5700 },
      lastUpdated: '2 days ago',
      features: [
          'Real-time risk assessment', 
          'CI/CD integration', 
          'Detailed remediation reports'
      ],
      badges: ['Certified Secure', 'ISO Compliant'],
      compatibleWith: ['Web Applications', 'Cloud Services', 'On-Premise Infrastructure']
    },
    {
      id: 'phishing-analysis',
      name: 'Phishing Defense Suite',
      icon: <Fish className="w-8 h-8 text-white" />,
      description: 'Real-time phishing detection with AI-powered URL and content analysis',
      longDescription: 'Our advanced phishing detection system analyzes website structures, email content, and behavioral patterns to identify sophisticated phishing attempts with 99.7% accuracy.',
      color: 'bg-orange-600',
      link: '/Phishing',
      rating: 4.9,
      totalRatings: 1120,
      likes: 3450,
      isNew: false,
      isPremium: true,
      trendingScore: 95,
      category: 'threat-detection',
      usageStats: { orgs: 3800, deployments: 15700 },
      lastUpdated: '5 days ago',
      features: ['URL reputation scoring', 'Brand impersonation detection', 'Automated takedowns'],
      badges: ['AI-Powered', '99.7% Accuracy'],
      compatibleWith: ['Office 365', 'Google Workspace', 'Slack']
    },
    {
      id: 'hashing',
      name: 'HashVault Hashing Toolkit',
      icon: <Hash className="w-8 h-8 text-white" />,
      description: 'Cryptographic hashing algorithms with secure salt management',
      longDescription: 'Implement secure password storage and data integrity verification with our suite of hashing algorithms including SHA-3, BLAKE3, and Argon2 with automated salt generation.',
      color: 'bg-purple-600',
      link: '/hashing',
      rating: 4.5,
      totalRatings: 645,
      likes: 1870,
      isNew: false,
      isPremium: false,
      trendingScore: 87,
      category: 'cryptography',
      usageStats: { orgs: 2950, deployments: 12400 },
      lastUpdated: '2 weeks ago',
      features: ['Multiple algorithm support', 'Secure salt generation', 'Performance optimization'],
      badges: ['FIPS 180-4', 'PCI DSS Compliant'],
      compatibleWith: ['Node.js', 'Python', 'Java', '.NET']
    },
    {
      id: 'cryptography',
      name: 'Cryptography Suite',
      icon: <Lock className="w-8 h-8 text-white" />,
      description: 'Enterprise-grade encryption, key management, and secure communications',
      longDescription: 'Comprehensive cryptographic solutions including AES-256 encryption, RSA-4096, and post-quantum cryptography options with full key lifecycle management.',
      color: 'bg-indigo-600',
      link: '/crypto',
      rating: 4.7,
      totalRatings: 1245,
      likes: 3456,
      isNew: false,
      isPremium: true,
      trendingScore: 92,
      category: 'encryption',
      usageStats: { orgs: 4200, deployments: 18900 },
      lastUpdated: '1 week ago',
      features: ['AES-256 encryption', 'Quantum-resistant algorithms', 'HSM integration'],
      badges: ['FIPS 140-2', 'NIST Compliant'],
      compatibleWith: ['AWS KMS', 'Azure Key Vault', 'Google Cloud HSM']
    },
    {
      id: 'educonnect',
      name: 'EduConnect Security',
      icon: <GraduationCap className="w-8 h-8 text-white" />,
      description: 'Specialized protection for educational institutions and learning platforms',
      longDescription: 'Secure student data, prevent cheating in online exams, and protect educational resources with our specialized platform designed for schools and universities.',
      color: 'bg-green-600',
      link: '/educonnect',
      rating: 4.4,
      totalRatings: 387,
      likes: 1230,
      isNew: true,
      isPremium: false,
      trendingScore: 88,
      category: 'sector-specific',
      usageStats: { orgs: 850, deployments: 3200 },
      lastUpdated: '4 days ago',
      features: ['Exam proctoring', 'LMS integration', 'FERPA compliance'],
      badges: ['FERPA Ready', 'COPPA Compliant'],
      compatibleWith: ['Canvas', 'Blackboard', 'Moodle']
    },
    /*{
      id: 'backup',
      name: 'Secure Backup Vault',
      icon: <HardDrive className="w-8 h-8 text-white" />,
      description: 'Encrypted, immutable backups with ransomware protection',
      longDescription: 'Zero-trust encrypted backups with geo-redundancy and WORM (Write Once Read Many) storage to protect against ransomware and data corruption.',
      color: 'bg-teal-600',
      link: '/Backup',
      rating: 4.6,
      totalRatings: 876,
      likes: 2540,
      isNew: false,
      isPremium: true,
      trendingScore: 90,
      category: 'data-protection',
      usageStats: { orgs: 3600, deployments: 14300 },
      lastUpdated: '1 week ago',
      features: ['AES-256 encryption', 'Immutable storage', 'Point-in-time recovery'],
      badges: ['SOC 2 Type II', 'HIPAA Compliant'],
      compatibleWith: ['AWS S3', 'Azure Blob', 'Google Cloud Storage']
    },*/
    
    
    {
      id: 'network-diagnostic',
      name: 'CognitoNet/ Network diagnostic',
      icon: <Globe className="w-8 h-8 text-white" />,
      description: 'Comprehensive network diagnostics and threat detection',
      longDescription: 'Full-stack network monitoring with deep packet inspection, anomaly detection, and automated threat response for complete network visibility and security.',
      color: 'bg-cyan-600',
      link: '/CognitoNet',
      rating: 4.5,
      totalRatings: 765,
      likes: 2230,
      isNew: true,
      isPremium: false,
      trendingScore: 89,
      category: 'network-security',
      usageStats: { orgs: 2900, deployments: 11200 },
      lastUpdated: '2 days ago',
      features: ['Traffic analysis', 'Threat correlation', 'Bandwidth monitoring'],
      badges: ['ISO 27001', 'CIS Benchmarks'],
      compatibleWith: ['Cisco', 'Juniper', 'Palo Alto']
    }
  ];
  
  // Filter tools based on category and search query
  useEffect(() => {
    let results = securityTools;
    
    if (activeCategory !== 'all') {
      results = results.filter(tool => tool.category === activeCategory);
    }
    
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      results = results.filter(tool => 
        tool.name.toLowerCase().includes(query) || 
        tool.description.toLowerCase().includes(query)
      );
    }
    
    // Sort the results
    switch(sortBy) {
      case 'rating':
        results = [...results].sort((a, b) => b.rating - a.rating);
        break;
      case 'newest':
        results = [...results].sort((a, b) => a.isNew ? -1 : b.isNew ? 1 : 0);
        break;
      case 'popular':
        results = [...results].sort((a, b) => b.likes - a.likes);
        break;
      case 'trending':
      default:
        results = [...results].sort((a, b) => b.trendingScore - a.trendingScore);
    }
    
    setFilteredTools(results);
  }, [activeCategory, searchQuery, sortBy]);
  
  // Featured tool - rotates among premium tools
  
  
  const [featuredTool, setFeaturedTool] = useState(null);

  useEffect(() => {
    // Get all premium tools
    const premiumTools = securityTools.filter(tool => tool.isPremium);
    
    // Randomly select one if premium tools exist
    if (premiumTools.length > 0) {
      const randomIndex = Math.floor(Math.random() * premiumTools.length);
      setFeaturedTool(premiumTools[randomIndex]);
    }
  }, []);

  const handleDiscoverClick = () => {
    if (featuredTool) {   
      window.location.href = featuredTool.link 
    }
  };

  if (!featuredTool) return <div>Loading featured tool...</div>;

  return (
    <main className="container mx-auto px-4 py-8 flex-grow bg-gray-900 text-white">
      {/* Analytics Summary */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-xl p-4 shadow-lg flex items-center">
          <div className="bg-blue-700 p-3 rounded-lg mr-4">
            <ShieldAlert className="w-6 h-6" />
          </div>
          <div>
            <p className="text-blue-200 text-sm">Protected Assets</p>
            <p className="text-2xl font-bold">8,249</p>
            <p className="text-blue-300 text-xs">↑ 12% this month</p>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-purple-900 to-purple-800 rounded-xl p-4 shadow-lg flex items-center">
          <div className="bg-purple-700 p-3 rounded-lg mr-4">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <div>
            <p className="text-purple-200 text-sm">Threats Blocked</p>
            <p className="text-2xl font-bold">143,587</p>
            <p className="text-purple-300 text-xs">↑ 7% this week</p>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-green-900 to-green-800 rounded-xl p-4 shadow-lg flex items-center">
          <div className="bg-green-700 p-3 rounded-lg mr-4">
            <Users className="w-6 h-6" />
          </div>
          <div>
            <p className="text-green-200 text-sm">Protected Users</p>
            <p className="text-2xl font-bold">12,458</p>
            <p className="text-green-300 text-xs">↑ 5% this month</p>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-red-900 to-red-800 rounded-xl p-4 shadow-lg flex items-center">
          <div className="bg-red-700 p-3 rounded-lg mr-4">
            <Clock className="w-6 h-6" />
          </div>
          <div>
            <p className="text-red-200 text-sm">Average Response</p>
            <p className="text-2xl font-bold">3.2 min</p>
            <p className="text-red-300 text-xs">↓ 18% improvement</p>
          </div>
        </div>
      </div>
      
      {/* Featured Tool */}
      <div className="mb-12 relative overflow-hidden">
        <div className="absolute -right-24 -top-24 w-96 h-96 bg-blue-500 rounded-full opacity-10"></div>
        <div className="absolute -left-24 -bottom-24 w-72 h-72 bg-purple-500 rounded-full opacity-10"></div>
        
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 border border-gray-700 relative z-10">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-2/3 mb-6 md:mb-0 md:pr-8">
              <div className="flex items-center mb-4">
                <div className={`${featuredTool.color} p-4 rounded-lg mr-4`}>
                  {featuredTool.icon}
                </div>
                <div>
                  <span className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs px-3 py-1 rounded-full font-semibold">FEATURED SOLUTION</span>
                  <h2 className="text-3xl font-bold mt-2">{featuredTool.name}</h2>
                </div>
              </div>
              
              <p className="text-gray-300 text-lg mb-6">{featuredTool.longDescription}</p>
              
              <div className="flex flex-wrap gap-3 mb-6">
                {featuredTool.features.map((feature, index) => (
                  <span key={index} className="bg-gray-700 text-gray-300 px-3 py-1 rounded-full text-sm flex items-center">
                    <Check className="w-4 h-4 mr-1 text-green-400" /> {feature}
                  </span>
                ))}
              </div>
              
              <div className="flex flex-wrap gap-2 mb-6">
                {featuredTool.badges.map((badge, index) => (
                  <span key={index} className="bg-blue-900 text-blue-200 px-3 py-1 rounded-full text-sm">
                    {badge}
                  </span>
                ))}
              </div>
              
              <div className="flex items-center space-x-2 mb-6">
                <ToolRating rating={featuredTool.rating} totalRatings={featuredTool.totalRatings} />
              </div>
              
              <button 
                onClick={handleDiscoverClick}
                className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-3 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg flex items-center">
                Discover {featuredTool.name} <ChevronRight className="w-5 h-5 ml-2" />
              </button>
            </div>
            
            <div className="md:w-1/3 bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 border border-gray-700 shadow-xl">
              <h3 className="text-lg font-semibold mb-4 text-gray-300">Why Security Teams Choose Us</h3>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="bg-green-900 p-2 rounded mr-3">
                    <Check className="w-4 h-4 text-green-400" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-200">Enterprise-grade Security</p>
                    <p className="text-xs text-gray-400">Used by Fortune 500 companies</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-green-900 p-2 rounded mr-3">
                    <Check className="w-4 h-4 text-green-400" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-200">Seamless Integration</p>
                    <p className="text-xs text-gray-400">Works with your existing tools</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-green-900 p-2 rounded mr-3">
                    <Check className="w-4 h-4 text-green-400" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-200">24/7 Dedicated Support</p>
                    <p className="text-xs text-gray-400">Average response time of 15 minutes</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-green-900 p-2 rounded mr-3">
                    <Check className="w-4 h-4 text-green-400" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-200">Continuous Updates</p>
                    <p className="text-xs text-gray-400">Stay ahead of emerging threats</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 p-4 bg-blue-900 bg-opacity-30 rounded-lg border border-blue-800">
                <p className="text-sm text-blue-200 flex items-center">
                  <Users className="w-4 h-4 mr-2" />
                  <span>
                    <strong>{featuredTool.usageStats.orgs.toLocaleString()}+</strong> organizations trust us
                  </span>
                </p>
                <p className="text-sm text-blue-200 flex items-center mt-2">
                  <Shield className="w-4 h-4 mr-2" />
                  <span>
                    <strong>{featuredTool.usageStats.deployments.toLocaleString()}+</strong> active deployments
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Tool Search and Filtering */}
      <div className="mb-8 bg-gray-800 rounded-xl p-4 border border-gray-700">
        <div className="flex flex-col sm:flex-row items-center justify-between mb-4">
          <h2 className="text-2xl font-bold mb-4 sm:mb-0">Security Tools</h2>
          
          <div className="flex items-center space-x-2 w-full sm:w-auto">
            <div className="relative flex-grow">
              <input
                type="text"
                placeholder="Search tools..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="bg-gray-700 text-white px-10 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
              {searchQuery && (
                <button 
                  onClick={() => setSearchQuery('')}
                  className="absolute right-3 top-2.5 text-gray-400 hover:text-white"
                >
                  <X className="w-5 h-5" />
                </button>
              )}
            </div>
            
            <button 
              onClick={() => setShowFilters(!showFilters)}
              className={`p-2 rounded-lg ${showFilters ? 'bg-blue-600' : 'bg-gray-700'} hover:bg-blue-700 transition-colors`}
            >
              <Filter className="w-5 h-5" />
            </button>
          </div>
        </div>
        
        {showFilters && (
          <div className="p-4 bg-gray-700 rounded-lg mb-4 animate-fadeIn">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div>
                <p className="text-sm font-medium mb-2">Categories</p>
                <div className="flex flex-wrap gap-2">
                  {categories.map(category => (
                    <button
                      key={category.id}
                      onClick={() => setActiveCategory(category.id)}
                      className={`px-3 py-1 rounded-full text-sm ${
                        activeCategory === category.id 
                          ? 'bg-blue-600 text-white' 
                          : 'bg-gray-600 text-gray-200 hover:bg-gray-500'
                      }`}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              </div>
              
              <div>
                <p className="text-sm font-medium mb-2">Sort by</p>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="bg-gray-600 text-white px-3 py-1 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="trending">Trending</option>
                  <option value="rating">Highest Rated</option>
                  <option value="newest">Newest</option>
                  <option value="popular">Most Popular</option>
                </select>
              </div>
            </div>
          </div>
        )}
        
        <div className="flex items-center justify-between text-sm text-gray-400">
          <div>
            <p>Showing {filteredTools.length} tools {activeCategory !== 'all' && `in ${categories.find(c => c.id === activeCategory)?.name}`}</p>
          </div>
          
          <button className="flex items-center hover:text-white transition-colors">
            <RefreshCw className="w-4 h-4 mr-1" /> Refresh
          </button>
        </div>
      </div>
      
      {/* Tools Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filteredTools.map((tool) => (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            key={tool.id}
            className="
              bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6
              border border-gray-700
              hover:border-blue-500
              transition-all duration-300
              transform hover:-translate-y-2
              hover:shadow-xl hover:shadow-blue-900/20
              relative
              overflow-hidden
              group
            "
          >
            {/* Accent background element */}
            <div className="absolute -right-6 -top-6 w-12 h-12 rounded-full bg-blue-600 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
            
            {/* Badge indicators */}
            <div className="absolute top-3 right-3 flex space-x-2">
              {tool.isNew && (
                <div className="bg-green-500 text-white text-xs px-2 py-1 rounded-full flex items-center">
                  <span className="w-1.5 h-1.5 bg-white rounded-full mr-1 animate-pulse"></span>
                  New
                </div>
              )}
              {tool.isPremium && (
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs px-2 py-1 rounded-full">
                  Premium
                </div>
              )}
            </div>
            
            {/* Tool icon */}
            <div className={`${tool.color} w-14 h-14 rounded-xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform`}>
              {tool.icon}
            </div>
            
            {/* Tool info */}
            <h3 className="text-lg font-semibold mb-2 group-hover:text-blue-400 transition-colors">{tool.name}</h3>
            <p className="text-sm text-gray-400 mb-4">{tool.description}</p>
            
            {/* Compatibility badges */}
            {tool.compatibleWith && (
              <div className="flex flex-wrap gap-1 mb-3">
                {tool.compatibleWith.slice(0, 3).map((platform, idx) => (
                  <span key={idx} className="text-xs px-2 py-0.5 bg-gray-700 text-gray-300 rounded">
                    {platform}
                  </span>
                ))}
                {tool.compatibleWith.length > 3 && (
                  <span className="text-xs px-2 py-0.5 bg-gray-700 text-gray-300 rounded">
                    +{tool.compatibleWith.length - 3} more
                  </span>
                )}
              </div>
            )}
            
            {/* Tool ratings */}
            <ToolRating rating={tool.rating} totalRatings={tool.totalRatings} />
            
            {/* Social proof */}
            <SocialProof tool={tool} />
            
            {/* Usage and trend info */}
            <div className="mt-4 flex items-center justify-between text-xs">
              <span className="flex items-center text-green-400">
                <TrendingUp className="w-4 h-4 mr-1" />
                Trending: {tool.trendingScore}%
              </span>
              <span className="text-gray-400">Updated {tool.lastUpdated}</span>
            </div>
            
            {/* Action button */}
            <div className="mt-4">
                <button
                onClick={() => navigate(tool.link)}
                className="
                    w-full bg-gradient-to-r from-blue-600 to-blue-700
                    text-white px-4 py-2 rounded-lg
                    hover:from-blue-700 hover:to-blue-800
                    transition-all duration-300
                    flex items-center justify-center
                "
                >
                Explore Tool
                <ChevronRight className="w-4 h-4 ml-1" />
                </button>
            </div>
            
            {/* Quick action buttons */}
            <div className="absolute bottom-2 right-2 flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <button className="p-1.5 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors" title="Save">
                <Bookmark className="w-3.5 h-3.5 text-gray-300" />
              </button>
              <button className="p-1.5 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors" title="Share">
                <Share2 className="w-3.5 h-3.5 text-gray-300" />
              </button>
            </div>
          </motion.div>
        ))}
      </div>
      
      {/* No results message */}
      {filteredTools.length === 0 && (
        <div className="text-center py-12">
          <div className="bg-gray-800 inline-block p-4 rounded-full mb-4">
            <Search className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-xl font-medium mb-2">No tools found</h3>
          <p className="text-gray-400 mb-4">Try adjusting your search or filters</p>
          <button 
            onClick={() => {
              setSearchQuery('');
              setActiveCategory('all');
              setSortBy('trending');
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Reset filters
          </button>
        </div>
      )}
      
      {/* Additional call to action */}
      <div className="mt-16 bg-gradient-to-r from-blue-900 to-indigo-900 rounded-xl p-8 shadow-lg relative overflow-hidden">
        <div className="absolute -right-10 -top-10 w-40 h-40 bg-blue-600 rounded-full opacity-20"></div>
        <div className="absolute -left-10 -bottom-10 w-40 h-40 bg-indigo-600 rounded-full opacity-20"></div>
        
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-2/3 mb-6 md:mb-0">
            <h3 className="text-2xl font-bold mb-2">Ready to elevate your security posture?</h3>
            <p className="text-blue-200 mb-4">Get a personalized security assessment and see how our tools can protect your organization.</p>
            <div className="flex flex-wrap gap-4">
              <button className="bg-white text-blue-900 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors shadow-lg flex items-center">
                Request Demo <ChevronRight className="w-5 h-5 ml-2" />
              </button>
              <button className="bg-transparent border border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors">
                View Pricing
              </button>
            </div>
          </div>
          
          <div className="md:w-1/3 bg-blue-800 bg-opacity-50 p-5 rounded-xl border border-blue-700">
            <div className="text-center">
              <div className="inline-block bg-blue-700 p-3 rounded-full mb-3">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h4 className="font-semibold mb-3">Enterprise Security Suite</h4>
              <div className="flex items-center justify-center mb-3">
                <span className="line-through text-blue-300 mr-2">$1,999</span>
                <span className="text-xl font-bold">$1,499</span>
                <span className="text-blue-300 ml-2">/month</span>
              </div>
              <p className="text-blue-200 text-sm mb-4">Limited time offer - 25% discount</p>
              <div className="bg-blue-900 bg-opacity-50 p-2 rounded-lg text-xs text-blue-200 mb-4">
                Only 5 enterprise packages remaining at this price
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

// Enhanced Rating Component with hover effects
const ToolRating = ({ rating, totalRatings }) => {
  return (
    <div className="flex items-center space-x-1">
      {[...Array(5)].map((_, index) => (
        <Star
          key={index}
          className={`w-5 h-5 ${index < Math.floor(rating) ? 'text-yellow-500' : 'text-gray-600'} 
            transition-colors duration-300 ${index < Math.floor(rating) ? 'hover:text-yellow-400' : 'hover:text-gray-500'}`}
          fill={index < Math.floor(rating) ? '#FFD700' : 'none'}
        />
      ))}
      <span className="text-sm text-gray-400 ml-2">
        ({rating.toFixed(1)}) • {totalRatings.toLocaleString()} ratings
      </span>
    </div>
  );
};

// Enhanced Social Proof Component with animations
const SocialProof = ({ tool }) => {
  const [likes, setLikes] = useState(tool.likes);
  const [hasLiked, setHasLiked] = useState(false);
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  
  const handleLike = () => {
    setLikes(hasLiked ? likes - 1 : likes + 1);
    setHasLiked(!hasLiked);
  };
  
  return (
    <div className="flex items-center space-x-3 mt-3">
      <button
        onClick={handleLike}
        className={`
          flex items-center space-x-1
          px-3 py-1 rounded-full
          transition-all duration-300
          ${hasLiked 
            ? 'bg-blue-600 bg-opacity-20 text-blue-400 border border-blue-600'
            : 'bg-gray-700 text-gray-400 hover:bg-gray-600 border border-transparent'}
        `}
      >
        <ThumbsUp className={`w-4 h-4 ${hasLiked ? 'text-blue-400' : ''}`} />
        <span>{likes.toLocaleString()}</span>
      </button>
      
      <div className="relative">
        <button
          onClick={() => setShowShareOptions(!showShareOptions)}
          className={`
            p-2 rounded-full
            transition-colors
            ${showShareOptions 
              ? 'bg-gray-700 text-blue-400' 
              : 'text-gray-400 hover:text-gray-300 hover:bg-gray-700'}
          `}
          title="Share Tool"
        >
          <Share2 className="w-4 h-4" />
        </button>
        
        {showShareOptions && (
          <div className="absolute bottom-full mb-2 right-0 bg-gray-800 rounded-lg p-2 shadow-lg border border-gray-700 flex space-x-1 z-20">
            <button className="p-2 hover:bg-gray-700 rounded" title="Copy Link">
              <Link className="w-4 h-4 text-gray-400" />
            </button>
            <button className="p-2 hover:bg-gray-700 rounded" title="Twitter">
              <Twitter className="w-4 h-4 text-gray-400" />
            </button>
            <button className="p-2 hover:bg-gray-700 rounded" title="Email">
              <Mail className="w-4 h-4 text-gray-400" />
            </button>
          </div>
        )}
      </div>
      
      <button
        onClick={() => setIsBookmarked(!isBookmarked)}
        className={`
          p-2 rounded-full
          transition-colors
          ${isBookmarked 
            ? 'text-amber-400' 
            : 'text-gray-400 hover:text-gray-300 hover:bg-gray-700'}
        `}
        title={isBookmarked ? "Saved" : "Save for later"}
      >
        <Bookmark className="w-4 h-4" fill={isBookmarked ? "currentColor" : "none"} />
      </button>
    </div>
  );
};

// New component for the Check icon
const Check = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

// New component for the Link icon
const Link = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
);

// New component for the Twitter icon
const Twitter = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
  </svg>
);

// New component for the Mail icon
const Mail = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

// New component for the Shield icon
const Shield = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

// Additional animation component for fading in
const X = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export default EnhancedSecDashboard;
